import { Stack } from "@/components/ui";
import { FlujoCard } from "@/features/autorizacion/components/FlujoCard";
import type { SolicitudDetalle } from "@/lib/types";
import { RechazoBanner } from "./RechazoBanner";
import { DadaDeBajaAlert } from "./DadaDeBajaAlert";

/**
 * Tab Autorización · banner de rechazo (si aplica) + banner de baja
 * (si aplica) + timeline del flujo.
 */
export function AutorizacionTab({ sol }: { sol: SolicitudDetalle }) {
  return (
    <Stack gap="md">
      {sol.estado === "RechazadaParaCorreccion" && sol.ultimoMotivoRechazo.length > 0 && (
        <RechazoBanner
          solicitudId={sol.id}
          solicitanteId={sol.solicitanteId}
          motivos={sol.ultimoMotivoRechazo}
          nivelDelRechazo={sol.flujo?.nivelActual ?? null}
        />
      )}
      {sol.estado === "DadaDeBajaPorAutorizador" && (
        <DadaDeBajaAlert
          motivos={sol.motivosBaja}
          dadaDeBajaPorNombre={sol.dadaDeBajaPorNombre}
          dadaDeBajaAt={sol.dadaDeBajaAt}
        />
      )}
      {sol.flujo && <FlujoCard flujo={sol.flujo} />}
    </Stack>
  );
}
